import { render } from "./NotificationsIcon.vue?vue&type=template&id=15601572"
import script from "./NotificationsIcon.vue?vue&type=script&lang=js"
export * from "./NotificationsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__